import React, { useMemo, useState } from "react";
import {
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Typography,
  Tooltip
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

export default function FollowUpBell({ leads }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const upcoming = useMemo(() => {
    const today = new Date();

    return leads.filter((l) => {
      if (!l.followUp) return false;

      const date = new Date(l.followUp);
      const diff = (date - today) / (1000 * 60 * 60 * 24);

      return diff >= 0 && diff <= 3; // next 3 days
    });
  }, [leads]);

  return (
    <>
      <Tooltip title="Upcoming Follow-ups">
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Badge badgeContent={upcoming.length} color="error">
            <NotificationsIcon
              sx={{ color: upcoming.length ? "#ff9800" : "#fff" }}
            />
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {upcoming.length === 0 ? (
          <MenuItem>No upcoming follow-ups</MenuItem>
        ) : (
          upcoming.map((lead) => (
            <MenuItem key={lead.id}>
              <Typography variant="body2">
                <b>{lead.name}</b> – {lead.product}
                <br />
                Follow-up: {lead.followUp}
              </Typography>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
}
